import { useMutation } from '@tanstack/react-query'
import { useToast } from '@zet/common/components/toast'
import { i18n } from '@zet/localization'

import { resendOtpSecondaryPhoneNumber } from '../functions'

function useSecondaryPhoneNumberResendOtp() {
  const toast = useToast()

  return useMutation(resendOtpSecondaryPhoneNumber, {
    onSuccess(response) {
      const { reason, lockedTill } = response

      if (lockedTill) {
        toast?.show({
          intent: 'error',
          heading: i18n.t('toastMessages.error'),
          description: reason,
          hideAfter: 3000,
        })
      }
    },
    onError(error: string) {
      toast?.show({
        intent: 'error',
        heading: i18n.t('toastMessages.error'),
        description: i18n.t('toastMessages.somethingWentWrong'),
        hideAfter: 3000,
      })
    },
  })
}
export { useSecondaryPhoneNumberResendOtp }
